// Imports
import * as Sentry from '@sentry/browser';
import convertPlainQuotes from '../../../utils/formatting/convert-plain-quotes';


/** Modifies Stripe error messages to a user friendly version if needed, or report to Sentry if they contain unwanted references or a URL */
export default function modifyStripeMessage(message: string) {
	// Initialize lower-case of message
	const messageLowercase = message.toLowerCase();
	
	
	// Modify specific messages
	if (messageLowercase.includes('previous attempts to deliver payouts to this account have failed')) {
		return 'You cannot use this bank account because our payment processing partner has had trouble sending funds to it in the past. Please double-check the account details and contact our customer success team if you think this is a mistake.';
	}
	
	if (messageLowercase.includes('previous payments or payouts with this account have failed')) {
		return 'You cannot use this bank account because our payment processing partner has had trouble using it in the past. Please double-check the account details and contact our customer success team if you think this is a mistake.';
	}
	
	if (messageLowercase.includes('has been denylisted because a previous payment')) {
		return 'You cannot use this bank account because a previous payment made with it failed. Please double-check the account details, use a different payment method, or contact our customer success team if you think this is a mistake.';
	}
	
	
	// Create list of whole words used
	const words = messageLowercase.split(/[^a-z]/).filter((word) => word.length > 0);
	
	
	// Log message having 'business' or 'company'
	if (words.includes('business') || words.includes('company')) {
		Sentry.captureMessage(`Stripe message has 'business' or 'company': ${message}`);
	}
	
	
	// Log message having embedded URL or Stripe reference
	if (message.includes('://') || words.includes('stripe')) {
		Sentry.captureMessage(`Stripe message has URL or Stripe reference: ${message}`);
	}
	
	
	// Convert to smart quotes
	let result = convertPlainQuotes(message);
	
	
	// Modify specific phrases
	result = result.replace(/zip code/gi, 'postal code');
	
	
	// Trim extra spaces
	result = result.trim();
	
	
	// End the line with a period
	result = result.replace(/[^.]$/g, '$&.');
	
	
	// Remove extraneous periods
	result = result.replace(/(\.[”’])(\.)/g, '$1');
	
	
	// Return
	return result;
}
